import { Document } from "../types";

const DEFAULT_DOCUMENT_TITLE = "Untitled";

export const getDocumentTitle = (doc: Document | undefined) =>
  doc?.title ?? DEFAULT_DOCUMENT_TITLE;
